export default "__VITE_ASSET__127b423b__"